<template>
    <div class="py-4">
        <modal-filter v-if="onfilter" :onfilter="onfilter" :filter="filter" @onclose="onfilter = false" @onfilter="ONFILTER()" :exclude="['user_id']"/>
        <modal-delete v-if="ondelete" :ondelete="ondelete" :id="id" @onclose="ondelete = false" @onreload="ONFILTER()" />
        <header>
            <div class="container-fluid">
                <div class="pb-4">
                    <div class="row align-items-end">
                        <div class="col-sm col-12">
                            <h1 class="h2 ls-tight">Mis paquetes</h1>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main>
            <div class="container-fluid">
                <div class="vstack gap-4">
                    <div class="d-flex flex-column flex-md-row gap-3 justify-content-between">
                        <form class="d-flex gap-3 row" @submit.prevent="FILTER()">
                            <div>
                                <button @click="onfilter = true" type="button" class="btn btn-h px-3 btn-neutral">
                                    <i class="bi bi-funnel me-2"></i>
                                    <span>Filtro</span>
                                    <span class="vr opacity-20 mx-3"></span>
                                    <span class="text-xs text-primary">{{ count_filter }}</span>
                                </button>
                            </div>
                            <div>
                                <button @click="SORT()" type="button" class="btn btn-h px-3 btn-neutral">
                                    <i class="me-2"
                                        :class="filter.sortDesc == 'ASC' ? 'bi bi-sort-alpha-up' : 'bi bi-sort-alpha-down-alt'"></i>
                                    <span>{{ filter.sortDesc }}</span>
                                </button>
                            </div>
                            <div class="col-md-4 px-0">
                                <div class="input-group input-group-sm input-group-inline">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text pe-2 text-sm"><i class="bi bi-search"></i></span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="Buscar..." v-model="filter.search">
                                </div>
                            </div>
                            <div>
                                <button type="submit" class="btn btn-h px-3 btn-primary">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="loading == 'filter'">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Buscar</span>
                                </button>
                            </div>
                            <div>
                                <button type="button" class="btn btn-h px-3 btn-danger" @click="CLEAR()">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="loading == 'clear'">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <span v-else>Limpiar</span>
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="card">
                        <div class="card-header bg-white">
                            <h5 class="me-auto">Listado</h5>
                        </div>
                        <div class="card-body p-0">
                            <template>
                                <v-data-table  class="elevation-1"
                                    :headers="headers"
                                    :items="loading == 'table' || loading == 'sort' || loading == 'filter' || loading == 'clear' ? [] : items.data"
                                    :options.sync="options"
                                    :server-items-length="items.total"
                                    :loading="loading == 'table' || loading == 'sort' || loading == 'filter' || loading == 'clear'"
                                    :footer-props="{
                                        'items-per-page-options': [5, 10, 50, 100]
                                    }">
                                    <template v-slot:[`item.id`]="{ item }">
                                        {{
                                            items.to >= 10 ? items.to - options.itemsPerPage + items.data.indexOf(item) +
                                                1 : items.data.indexOf(item) + 1
                                        }}
                                    </template>
                                    <template v-slot:[`item.id`]="{ item }">
                                        <router-link :to="{ name: 'PackageDetailPrealert', params: { id: item.id } }"
                                            class="text-decoration-none">
                                            {{ item.type }}{{ item.id }}
                                        </router-link>
                                    </template>
                                    <template v-slot:[`item.state.name`]="{ item }">
                                        <span class="badge badge-pill" :class="item.state.labels ? item.state.labels : 'badge-light'">{{ item.state.name }}</span>
                                    </template>
                                    <template v-slot:[`item.description`]="{ item }">
                                        <v-tooltip bottom class="mx-1">
                                            <template v-slot:activator="{ on, attrs }">
                                                <div v-bind="attrs" v-on="on" class="nowrap" v-if="Array.isArray(item.description)">
                                                    {{ item.description[0] }} ...
                                                </div>
                                            </template>
                                            <small><div v-for="(description, key) in  item.description" :key="key">{{ description }}</div></small>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:[`item.invoice`]="{ item }">
                                        <button v-if="!item.invoice" type="button" disabled
                                            class="btn btn-outline-dark btn-m">
                                            <small><i class="bi bi-file-earmark-font"></i></small>
                                        </button>
                                        <v-tooltip top v-else>
                                            <template v-slot:activator="{ on, attrs }">
                                                <button type="button" @click="PRINT_INVOICE(item.id)" v-bind="attrs" v-on="on"
                                                    class="btn btn-success btn-h px-3">
                                                    <small class="d-flex align-items-center justify-content-center"><i
                                                            class="fa-solid fa-dollar mr-1"></i> {{
                                                                Number(item.invoice.total || 0).toFixed(2)
                                                            }}</small>
                                                </button>
                                            </template>
                                            <small>Factura</small>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:[`item.update`]="{ item }">
                                        <v-tooltip top v-if="globalViewOption('PackageUpdatePrealert') && item.state_id <= 4 && item.validated == 0">
                                            <template v-slot:activator="{ on, attrs }">
                                                <a v-bind="attrs" v-on="on">
                                                    <router-link
                                                        :to="{ name: 'PackageUpdatePrealert', params: { id: item.id } }"
                                                        class="btn btn-primary btn-m">
                                                        <small><i class="bi bi-pencil-square"></i></small>
                                                    </router-link>
                                                </a>
                                            </template>
                                            <small>Editar</small>
                                        </v-tooltip>
                                        <button v-else disabled type="button"
                                            class="btn btn-primary btn-m">
                                            <small><i class="bi bi-pencil-square"></i></small>
                                        </button>
                                    </template>
                                    <template v-slot:[`item.delete`]="{ item }">
                                        <v-tooltip top v-if="globalViewOption('PackageDeletePrealert') && item.state_id == 1 && item.validated == 0">
                                            <template v-slot:activator="{ on, attrs }">
                                                <button @click="DELETE(item.id)" type="button" v-bind="attrs" v-on="on"
                                                    class="btn btn-danger btn-m">
                                                    <small><i class="bi bi-trash3"></i></small>
                                                </button>
                                            </template>
                                            <small>Eliminar</small>
                                        </v-tooltip>
                                        <button v-else disabled type="button"
                                            class="btn btn-danger btn-m">
                                            <small><i class="bi bi-trash3"></i></small>
                                        </button>
                                    </template>
                                    <template v-slot:[`item.details`]="{ item }">
                                        <v-tooltip top v-if="globalViewOption('PackageDetailPrealert')">
                                            <template v-slot:activator="{ on, attrs }">
                                                <a v-bind="attrs" v-on="on">
                                                    <router-link
                                                        :to="{ name: 'PackageDetailPrealert', params: { id: item.id } }"
                                                        class="btn btn-info btn-m">
                                                        <small><i class="bi bi-card-list"></i></small>
                                                    </router-link>
                                                </a>
                                            </template>
                                            <small>Mostrar detalles</small>
                                        </v-tooltip>
                                    </template>
                                </v-data-table>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import ModalFilter from '../modals/Filter'
import ModalDelete from './DeletePrealert'
export default {
    components: { ModalFilter, ModalDelete },
    data() {
        return {
            headers: [				
                { text: 'GVT', value: 'id', sortable: false },
                { text: 'Tracking', value: 'tracking', sortable: false },
                { text: 'Descripción', value: 'description', sortable: false },
                { text: 'Estado', value: 'state.name', sortable: false },
                { text: 'Cargos', value: 'invoice', sortable: false },
                { text: 'Editar', value: 'update', sortable: false },
                { text: 'Borrar', value: 'delete', sortable: false },
                { text: 'Detalles', value: 'details', sortable: false },
            ],
            items: {
                data: [],
                total: 0,
                to: 0
            },
            loading: '',
            expanded: [],
            options: {},
            filter: {
                operator: 'LIKE',
                sortBy: 'id',
                sortDesc: 'DESC',
                fields: ['id', 'tracking'],
                search: '',
                loading: '',
                state_id: [],
                payment_state_id: []
            },
            onfilter: false,
            ondelete: false,
            id: null,
            count: 0,
            cancelToken: null,
        }
    },
    computed: {
        count_filter: function(){
            let count = 0;
            let vue = this
            Object.entries(vue.filter).forEach((e) => {
                if(e[0] != 'sortBy' && e[0] != 'sortDesc' && e[0] != 'search' && e[0] != 'loading'){
                    if(typeof e[1] == 'object'){
                        if(e[1]){
                            if(e[1].length > 0){
                                count++
                            }
                        }
                    }else{
                        if(e[1]){
                            count++
                        }
                    }   
                }
            })
            return count;
        }
    },
    methods: {
        INIT: function () {
            let vue = this
            const source = axios.CancelToken.source()
            vue.cancelToken = source
            const { page, itemsPerPage } = vue.options
            let query = {
                page: page,
                itemsPerPage: itemsPerPage,
            }
            Object.entries(vue.filter).forEach((e) => {
                query[e[0]] = e[1]
            })
            axios({
                url: '/clients/packages',
                method: 'GET',
                params: query,
                cancelToken: source.token,
            })
                .then((resp) => {
                    vue.items = resp.data
                    vue.loading = ''
                })
                .catch((err) => {
                    if (err.code !== 'ERR_CANCELED') {
                        if (err.response.status === 402) {
                            let message = err.response ? err.response.data.message : err.message
                            vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        } else {
                            vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                        }
                        vue.loading = ''
                    }
                })
        },
        SORT: function () {
            let vue = this
            if (vue.cancelToken) {
                vue.cancelToken.cancel("Solicitud cancelada");
            }
            vue.filter.sortDesc = vue.filter.sortDesc == 'ASC' ? 'DESC' : 'ASC'
            vue.loading = 'sort'
            vue.INIT()
        },
        ONFILTER: function(){
            let vue = this
            vue.onfilter = false
            vue.loading = 'table'
            if (vue.cancelToken) {
                vue.cancelToken.cancel("Solicitud cancelada");
            }
            vue.INIT()
        },
        FILTER: function () {
            let vue = this
            let count = 0
            if (vue.filter.search.length > 0) {
                count++
            }
            if (count > 0) {
                vue.loading = 'filter'
                if (vue.cancelToken) {
                    vue.cancelToken.cancel("Solicitud cancelada");
                }
                vue.INIT()
            }
        },
        CLEAR: function () {
            let vue = this
            vue.loading = 'clear'
            vue.filter = {
                operator: 'LIKE',
                sortBy: 'id',
                sortDesc: 'DESC',
                fields: ['id', 'tracking'],
                search: '',
                loading: '',
                state_id: [],
                payment_state_id: []
            }
            if (vue.cancelToken) {
                vue.cancelToken.cancel("Solicitud cancelada");
            }
            vue.INIT()
        },
        DELETE: function (id) {
            let vue = this
            vue.id = id
            vue.ondelete = true
        },
        PRINT_INVOICE: function(id){
            let vue = this
            const routeData = vue.$router.resolve({name: 'PackageInvoice', params: { id: id }})
            window.open(routeData.href, '_blank')
        }
    },
    watch: {
        options: {
            handler() {
                if (this.cancelToken) {
                    this.cancelToken.cancel("Solicitud cancelada");
                }
                this.loading = 'table'
                this.INIT()
            },
            deep: true
        }
    }
}
</script>

view-packages-me